import { inject, observer } from "mobx-react";
import React from "react";
import { TextField } from "@material-ui/core";
import Notification from "../notification/notification";
import { ClientModel } from "../../../helpers/client";
import { UiFlagsStore } from "../../../stores/uiFlagsStore";

interface PhoneFieldProps {
  client: ClientModel;
  onChange: (newValue: any) => void;
  value: string;
  id?: string;
  disabled?: boolean;
  uiFlagsStore?: UiFlagsStore;
}

@inject("uiFlagsStore")
@observer
export default class PhoneField extends React.Component<PhoneFieldProps> {

  public render() {
    const phoneRequired = this.props.uiFlagsStore!.isDirect || this.props.uiFlagsStore!.isClientEndsSelected;
    return (<TextField
      variant="outlined"
      size="small"
      disabled={this.props.disabled}
      error={!!this.props.client.phone.errorMessage}
      helperText={this.getHelperText(phoneRequired)}
      inputProps={{ maxLength: 28 }}
      label="Numer telefonu"
      InputLabelProps={{
        shrink: true
      }}
      className="text-input"
      onChange={this.props.onChange}
      onBlur={(event) => {
        this.validate(phoneRequired);
      }}
      value={this.props.value}
    />);
  }

  private getHelperText(phoneRequired: boolean) {
    return (!!this.props.client.phone.errorMessage
      ? <Notification type="error" message={this.props.client.phone.errorMessage} />
      : (phoneRequired) ? "" : <Notification type="info" message="Opcjonalne" />);
  }

  public validate(required: boolean) {
    this.props.client.validatePhoneNumber(required);
  }
}
